import { config } from '../../config/config';

const URL_GREET_SHOPPER_ENCRYPTED: string = `${config.CHATSERVER_URL}/api/Shopper/GreetShopperEncrypted`;
const URL_SHOPPER_GET_ORDER_DETAIL: string = `${config.CHATSERVER_URL}/api/Shopper/GetOrderDetail`;
const URL_SHOPPER_GET_SUBSCRIPTION_DETAIL: string = `${config.CHATSERVER_URL}/api/Shopper/GetSubscriptionDetail`;
const AUTH_BACKWARD_COMPATIBILITY_SETTING: string = `${config.CHATSERVER_URL}/api/Settings/BackwardCompatibilitySetting`;
const URL_SETTINGS_GET_FEATURE: string = `${config.CHATSERVER_URL}/api/Settings/IsFeatureEnabled/`;
const URL_CONFIGURATIONS: string = `${config.CHATSERVER_URL}/api/Settings/GetWidgetConfiguration/bws`;

const requestPost = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': config.APIMGT_KEY,
        'Ak' : '',
        'Rt' : ''
    },
    body: JSON.stringify({})
};

const requestGet = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json','Ocp-Apim-Subscription-Key': config.APIMGT_KEY }
};

const greetLoggedInShopperEncrypted = async (encryptedShopperId: string, widgetSessionId: string, sessionId: string, userId: string, intentGroupId: string, intentGroupName: string, ak:string = '') => {
    try {
        requestPost.body = JSON.stringify({ 
            "encryptedShopperId": encryptedShopperId, 
            "widgetSessionId": widgetSessionId, 
            "dialogFlowSessionId" : sessionId , 
            "chatbotUserId" : userId,
            "intentGroupId" : intentGroupId,
            "intentGroupName" : intentGroupName,"source" : (config.ISSTAGING) ? 'bwsstaging' : config.SOURCE
        });

        if (ak !== '')
            requestPost.headers['Ak'] = ak;
        
        const response = await fetch(URL_GREET_SHOPPER_ENCRYPTED, requestPost);
        const result = await response.json();
        return result;
    } catch(error) {
        return error;
    }
    
}

const getOrderDetailByShopperId = async (shopperId: number, widgetSessionId: string, orderNumber: number, sessionId: string, userId: string) => {
    try {
        requestPost.body = JSON.stringify({ "shopperId": shopperId, "widgetSessionId": widgetSessionId, "dialogFlowSessionId" : sessionId , "chatbotUserId" : userId, "source" : config.SOURCE });
        const response = await fetch(`${URL_SHOPPER_GET_ORDER_DETAIL}/${ orderNumber }`, requestPost);
        const result = await response.json();
        return result;
    } catch(error) {
        console.log(JSON.stringify(error));
        return error;
    }   
}

const getSubscriptionDetailByShopperId = async (shopperId: number, widgetSessionId: string, subscriptionId: string) => {
    try {
        requestPost.body = JSON.stringify({ "shopperId": shopperId, "widgetSessionId": widgetSessionId });
        const response = await fetch(`${URL_SHOPPER_GET_SUBSCRIPTION_DETAIL}/${ subscriptionId }`, requestPost);
        const result = await response.json();
        return result;
    } catch(error) {
        console.log(JSON.stringify(error));
        return error;
    }
    
}

const getAuthBackwardCompatibilitySetting = async () => {
    try {
        const response = await fetch(`${ AUTH_BACKWARD_COMPATIBILITY_SETTING}`, requestGet);
        const result = await response.json();
        return result;
    } catch(error) {
        console.log(JSON.stringify(error));
        return error;
    }
    
}

const getFeatureSetting = async (featureName: string) => {
    try {
        const response = await fetch(`${ URL_SETTINGS_GET_FEATURE}${ featureName }`, requestGet);
        const result = await response.json();
        return result;
    } catch(error) {
        console.log(JSON.stringify(error));
        return error;
    }
    
}

const getConfigSettings = async () => {
    try {
        const response = await fetch(`${ URL_CONFIGURATIONS }`, requestGet);
        const result = await response.json();
        return result;
    } catch(error) {
        console.log(JSON.stringify(error));
        return error;
    }
}

export {
    getOrderDetailByShopperId,
    getSubscriptionDetailByShopperId,
    getAuthBackwardCompatibilitySetting,
    getFeatureSetting,
    getConfigSettings,
    greetLoggedInShopperEncrypted
}
